import React from "react";
import { FaRegUser } from "react-icons/fa";
import { IoHomeOutline, IoImageOutline } from "react-icons/io5";
import { RiPagesLine } from "react-icons/ri";
import { RxCross2 } from "react-icons/rx";
import { VscSend } from "react-icons/vsc";

import { Link } from "react-scroll";
function SubNav({ setReveal, reveal }) {
  return (
    <div
      className={`transition-all duration-300 
        font-medium text-[0.9rem] grid grid-cols-3
  w-full gap-x-6 gap-y-8 z-50 rounded-md h-[150px]`}
    >
      <div
        className="absolute bottom-5 right-0 hover:text-gray-700
      transition-all duration-300"
        onClick={() => {
          setReveal(true);
        }}
      >
        <RxCross2 fontSize={"1.5rem"} />
      </div>
      <Link
        to="home"
        spy={true}
        smooth={true}
        offset={0}
        duration={500}
        className="hover:text-gray-700 gap-2 flex flex-col items-center justify-center transition-all duration-300"
      >
        <span>
          <IoHomeOutline fontSize={"1.2rem"} />
        </span>
        Home
      </Link>

      <Link
        to="about"
        spy={true}
        smooth={true}
        offset={0}
        duration={500}
        className="hover:text-gray-700 gap-2 flex flex-col items-center justify-center  transition-all duration-300 "
      >
        <span>
          <FaRegUser fontSize={"1.2rem"} />
        </span>
        About
      </Link>

      <Link
        to="skills"
        spy={true}
        smooth={true}
        offset={0}
        duration={500}
        className="hover:text-gray-700 gap-2 flex flex-col items-center justify-center  transition-all duration-300 "
      >
        <span>
          <RiPagesLine fontSize={"1.2rem"} />
        </span>
        Skills
      </Link>

      <Link
        to="portfolio"
        spy={true}
        smooth={true}
        offset={0}
        duration={500}
        className="hover:text-gray-700 gap-2 flex flex-col items-center justify-center  transition-all duration-300 "
      >
        <span>
          {" "}
          <IoImageOutline fontSize={"1.2rem"} />
        </span>
        Portfolio
      </Link>

      <Link
        to="contact"
        spy={true}
        smooth={true}
        offset={0}
        duration={500}
        className="hover:text-gray-700 gap-2 flex flex-col items-center justify-center  transition-all duration-300 "
      >
        <span>
          <VscSend fontSize={"1.2rem"} />
        </span>
        Contact
      </Link>
    </div>
  );
}

export default SubNav;
